import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import {firstTdStyles, tdStyles} from "../Permissions/PermissionGroup.css";
import Toggle from "../TableInputs/Toggle";
import {middleThStyles, tableHeadStyles, thSpanStyles} from "../../styles/PermissionsTable.css";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {updateApps} from "../../../../../../actions/SecurityGroupActions";

class AppsTable extends Component {
    constructor(props){
        super(props);

        this.state = {
          apps: [],
          activeApps: []
        };
    }

  isToggleChecked = (appId) => {
    let apps = this.state.activeApps;
    return apps[appId] != null;
  };

  sortApps= (apps) => {
    let _apps = [];
    apps.forEach((app) => {
      let _app = {name: app.name, id: app.id};
      _apps.push(_app);
    });
    _apps.sort((a,b) => {
      return a["name"].localeCompare(b["name"]);
    });
    return _apps;
  };


    toggleAppActive = (appId) => {
      let activeApps = this.state.activeApps;
      if(activeApps[appId] != null)
        this.props.removeApp(appId);
      else {
        this.props.addApp(appId);
      }
    };


    componentWillReceiveProps(nextProps) {
      if(nextProps.activeApps !== this.state.activeApps) {
        this.setState({activeApps: nextProps.activeApps});
      }
    }

    componentDidMount() {
      if(this.props.securityGroupApps) {
        let activeApps = {};
        this.props.securityGroupApps.forEach(app => {
          activeApps[app] = app;
        });
        this.props.setApps(activeApps);
        this.setState({apps: this.props.apps, activeApps});
      }
    }

    render(){
      let {apps, disabled, features }= this.props;
      const filteredApps = apps.filter(app => {
        return features.find(f => f.id === app.featureId)
      });
      let _apps = this.sortApps(filteredApps);
      return(
        <div className="col-9">
          <table className="table">
            <thead style={tableHeadStyles}>
            <tr>
              <th></th>
              <th style={middleThStyles}><span style={thSpanStyles}>Access</span></th>
            </tr>
            </thead>
            <tbody>
            {_apps.map((_app, i) => {
              let insightsDisabled = _app.id === 'INS' && !features.some(feature => feature.id === 'INS-BE' || feature.id === 'INS-ENT');
              return(
                <tr key={i}>
                  <td style={{...firstTdStyles(disabled), cursor: 'default'}}>
                    <span>{_app.name}</span>
                  </td>
                  <td style={tdStyles}>
                    <Toggle name={_app.id} checked={this.isToggleChecked(_app.id)}
                            toggleSelected={this.toggleAppActive} disabled={insightsDisabled || disabled }/>
                  </td>
                </tr>
              );
            })}
            </tbody>
          </table>
        </div>
      );
    }
}


AppsTable.propTypes = {
  securityGroupApps: PropTypes.array.isRequired,
  apps: PropTypes.array.isRequired,
  features: PropTypes.array.isRequired,
  setApps: PropTypes.func.isRequired,
  addApp: PropTypes.func.isRequired,
  removeApp: PropTypes.func.isRequired,
  activeApps: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    apps: state.securityGroup.apps,
    features: state.securityGroup.features,
    securityGroupApps: state.securityGroup.securityGroup.appIds,
    activeApps: state.securityGroup.activeApps
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({setApps:updateApps}, dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(AppsTable);
